import { API_BASE_URL } from "../api/apiClient";

const ADMIN_BASE = "/api/admin/automotive";

async function parseJson(res) {
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "No pudimos cargar las solicitudes. Intenta nuevamente.");
  return data;
}

export function fetchAdminSellerSubmissions(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") qs.set(key, String(value));
  });
  const query = qs.toString();
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions${query ? `?${query}` : ""}`,
    { credentials: "include" }
  ).then(parseJson);
}

export function fetchAdminSellerSubmission(submissionId) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}`,
    { credentials: "include" }
  ).then(parseJson);
}

export function updateAdminSellerSubmissionNotes(submissionId, internalNotes) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/notes`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ internalNotes }),
    }
  ).then(parseJson);
}

export function updateAdminSellerSubmissionWorkflow(submissionId, payload = {}) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/workflow`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function convertAdminSellerSubmissionToListing(submissionId, payload = {}) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/convert-to-listing`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "No pudimos convertir la solicitud.");
    return data;
  });
}

export function updateAdminSellerSubmissionImage(submissionId, imageId, payload = {}) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/images/${encodeURIComponent(imageId)}`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function mapAdminSellerSubmissionImagesToListing(submissionId, listingId) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/images/map-to-listing`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ listingId }),
    }
  ).then(parseJson);
}

export function updateAdminSellerSubmissionCommunication(submissionId, payload = {}) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/communication`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function recordAdminSellerSubmissionContactAttempt(submissionId, payload = {}) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/contact-attempt`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function fetchAdminSellerSubmissionMessageTemplate(submissionId, templateId) {
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/${encodeURIComponent(submissionId)}/message-templates/${encodeURIComponent(templateId)}`,
    { credentials: "include" }
  ).then(parseJson);
}

export function fetchSellerIntakeMonitoringSummary(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") qs.set(key, String(value));
  });
  const query = qs.toString();
  return fetch(
    `${API_BASE_URL}${ADMIN_BASE}/seller-submissions/monitoring-summary${query ? `?${query}` : ""}`,
    { credentials: "include" }
  ).then(parseJson);
}
